@if ($visible()) {
    <div class="cm-container" [style.--arrowPosition]="$arrowRight()">
        <div class="cm-item-container" [style.min-width]="$minWidth()" [style.max-width]="$maxWidth()">
            <ng-content></ng-content>
        </div>
    </div>
}
